import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./service-request-detail-page.module.scss";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import { CustomerLoader } from "../../components";
import { FailedToLoadData } from "../../../../common/components/failed-to-load-data/FailedToLoadData";
import { TopBottomCuttedCard } from "../../../../common/components/top-bottom-cutted-card/TopBottomCuttedCard";
import { useGetServiceRequestInstanceCustomerQuery } from "../../../../service/customersupport-service";
import { shareReceiptAsPdf } from "../../../../common/utils/receipt/shareReceiptAsPdf";
import { shareReceiptAsImage } from "../../../../common/utils/receipt/shareReceiptAsImage";
import ServiceRequestReceiptCard from "./components/ServiceRequestReceiptCard";
import ServiceRequestShareBottomBar from "./components/ServiceRequestShareBottomBar";
import Button, { ButtonRadius, ButtonSize, ButtonStyle } from "../../../../common/components/button/button";

const SHARE_FILE_PREFIX = "service-request";

export const ServiceRequestDetailPage: React.FC = () => {
	const { id } = useParams<{ id: string }>();
	const numericId = Number(id);

	const { data: instance, isLoading, isError } = useGetServiceRequestInstanceCustomerQuery(numericId, {
		skip: !id || isNaN(numericId),
	});

	const receiptRef = useRef<HTMLDivElement>(null);
	const [isSharingPdf, setIsSharingPdf] = useState(false);
	const [isSharingImage, setIsSharingImage] = useState(false);

	const reference = instance?.instanceId ?? (instance?.id != null ? String(instance.id) : undefined);

	const handleSharePdf = async () => {
		if (!receiptRef.current || isSharingPdf) return;
		setIsSharingPdf(true);
		try {
			await shareReceiptAsPdf(receiptRef.current, reference, SHARE_FILE_PREFIX);
		} finally {
			setIsSharingPdf(false);
		}
	};

	const handleShareImage = async () => {
		if (!receiptRef.current || isSharingImage) return;
		setIsSharingImage(true);
		try {
			await shareReceiptAsImage(receiptRef.current, reference, SHARE_FILE_PREFIX);
		} finally {
			setIsSharingImage(false);
		}
	};

	const reportIssueButton = (
		<Button type="button" title="Report Issue"  onClick={() => {}} radius={ButtonRadius.PILL} style={ButtonStyle.WHITE} size={ButtonSize.SM} />
	);

	const renderBody = () => {
		if (isLoading) {
			return <CustomerLoader subtitle="Loading request details..." />;
		}

		if (isError || !instance) {
			return (
				<div className={styles.stateContainer}>
					<FailedToLoadData />
				</div>
			);
		}

		return (
			<>
				<div className={styles.receiptScroll}>
					<TopBottomCuttedCard ref={receiptRef} shareMode={true} className={styles.receiptCard}>
						<ServiceRequestReceiptCard instance={instance} />
					</TopBottomCuttedCard>
				</div>
				<ServiceRequestShareBottomBar
					onShareImage={handleShareImage}
					onSharePdf={handleSharePdf}
					isSharingImage={isSharingImage}
					isSharingPdf={isSharingPdf}
				/>
			</>
		);
	};

	return (
		<CustomerPageLayout
			title="Request Details"
			headerAction={reportIssueButton}
			contentContainerClass={styles.pageContent}
			contentMaxWidth={650}
		>
			<div className={styles.detailColumn}>{renderBody()}</div>
		</CustomerPageLayout>
	);
};
